<template>
  <div class="product-detail">
    <Load v-if="isLoading" />
    <template v-if="!isLoading && campaignStatus === 'active'">
      <!-- 
        TODO : Remove this banner
        <Banner
        v-if="stickyBanner"
        :image="stickyBanner"
        :link="stickyLink"
      /> -->
      <v-container>
        <!-- Content -->
        <div class="product-detail-layout gallery-square-layout">
          <div class="gallery pdp-preview-swiper">
            <template v-if="thumbnailList.length > 0">
              <PreviewImageSwiper
                loop
                showThumbnail
                allowTouchMove
                :medias="thumbnailList"
                :key="keyPreview"
              />
            </template>
          </div>

          <div
            class="pdp-content"
            :class="{ 'select-by-sku': isFromQRCode }"
          >
            <!-- Countdown -->
            <v-row v-if="timeLeft > -1" v-bind="{ justify: 'start' }">
              <v-col class="is-desktop">
                <h3 class="hurry-up-label">
                  <span class="harry-up">HURRY UP!</span>
                  CAMPAIGN END IN
                </h3>
                <div class="my-4">
                  <div class="is-desktop">
                    <CountDown
                      v-if="timeLeft > -1"
                      v-bind="{ size: 'md', justify: 'flex-start' }"
                      :timeLeft="timeLeft"
                      @end="reload"
                    />
                  </div>
                </div>
                <div class="my-2 hurry-up-label">
                  <span class="font-bold"
                    >สิ้นสุดการสั่งซื้อสินค้า :
                  </span>
                  {{ endDateTime | fullDataTh }}
                  เวลา {{ endTime }}
                </div>
              </v-col>

              <div class="is-mobile">
                <CountDown
                  v-if="timeLeft > -1"
                  v-bind="{ size: 'md', justify: 'flex-start' }"
                  :timeLeft="timeLeft"
                  :isPDP="true"
                  @end="reload"
                />
              </div>
            </v-row>
            <!-- End Countdown -->

            <!-- Model -->
            <v-row>
              <v-col cols="12">
                <div class="campaign-name-content">
                  <h1>{{ campaignName }}</h1>
                  <span class="text-label">
                    รหัสสินค้า : {{ sku }}
                  </span>
                </div>
                <div v-if="showFreeBie" class="product-label-layout">
                  <LabelProduct
                    v-if="isShowLabelFreebie"
                    labelType="free"
                    title="รับฟรีของแถม"
                    remark="ขอสงวนสิทธิ์ในการเปลี่ยนแปลงของแถมโดยไม่ต้องแจ้งให้ทราบล่วงหน้า"
                    :data="freebieItems"
                    showMore
                  />
                </div>
              </v-col>
              <v-col cols="12">
                <div
                  v-if="previewHtml"
                  v-html="previewHtml"
                  class="preview-html"
                ></div>

                <div
                  v-if="campaign.data.order_limit > 0"
                  class="text-red mt-2"
                >
                  สงวนสิทธิ์ในการสั่งจอง {{ campaignName }} 1 บัญชี/ 1
                  เครื่อง/ 1 เบอร์โทร/ 1 อีเมล เท่านั้น
                  หากพบว่าผิดเงื่อนไข บริษัทฯ
                  ขอสงวนสิทธิ์ในการยกเลิกคำสั่งซื้อทันที
                </div>
              </v-col>
              <div class="model-wrapper">
                <v-col cols="12">
                  <span class="text-label">Choose Model : </span>
                  <span class="font-bold">{{ modelName }}</span>
                </v-col>
                <v-col cols="12" class="model-container">
                  <ButtonModel
                    v-for="(item, index) in modelItems"
                    @click="
                      isFromQRCode &&
                      (isDisabled(item, 'model') || item === model)
                        ? null
                        : onClickModel(item)
                    "
                    :disabled="isDisabled(item, 'model')"
                    :select="item === model"
                    :title="item.name"
                    :price="item.start_price"
                    :key="index"
                  />
                </v-col>
              </div>
            </v-row>
            <!-- End Model -->

            <!-- Color -->

            <v-row>
              <div class="color-wrapper">
                <v-col cols="12">
                  <span class="text-label">Choose Color : </span>
                  <span class="font-bold">{{ selectColorName }}</span>
                </v-col>
                <v-col cols="12">
                  <div class="color-content">
                    <ButtonColor
                      v-for="(item, index) in colorItems"
                      @click="
                        isFromQRCode &&
                        (isDisabled(item, 'color') ||
                          item === selectColor)
                          ? null
                          : onClickColor(item)
                      "
                      :disabled="isDisabled(item, 'color')"
                      :color="item.color_hex"
                      :height="45"
                      :width="45"
                      :select="item === selectColor"
                      :key="index"
                    >
                    </ButtonColor>
                  </div>
                </v-col>
              </div>
            </v-row>

            <!-- End Color -->

            <!-- Capacity -->

            <v-row>
              <div class="capacity-wrapper">
                <v-col cols="12">
                  <span class="text-label">
                    Choose Capacity :
                    <span v-if="!selectColor" class="text-red pb-2">
                      * กรุณาเลือก{{ titleTextCapacity }}
                    </span>
                  </span>
                  <span class="font-bold">
                    {{ selectCapacityName }}
                  </span>
                </v-col>
                <v-col cols="12">
                  <div class="capacity-content">
                    <template v-if="selectColor">
                      <ButtonSpec
                        v-for="(item, index) in storageItems"
                        @click="
                          isFromQRCode &&
                          (isDisabled(item, 'capacity') ||
                            item === selectSKU)
                            ? null
                            : onClickCapacity(item)
                        "
                        :disabled="isDisabled(item, 'capacity')"
                        :title="item.size"
                        :select="item === selectSKU"
                        :key="index"
                      />
                    </template>
                    <template v-else>
                      <v-skeleton-loader
                        v-for="(item, index) in [0, 1, 2]"
                        type="button"
                        :key="index"
                      ></v-skeleton-loader>
                    </template>
                  </div>
                </v-col>
              </div>
            </v-row>

            <!-- End Capacity -->

            <!-- Select Take/not freebies -->
            <v-row v-if="isBundlesItemsUnsetFree" class="mb-4">
              <v-col cols="12">
                <span class="text-label">
                  สิทธิพิเศษ
                </span>
              </v-col>
              <v-col cols="12">
                <AccessoryBundle
                  v-for="(item, index) in bundlesItemsUnsetFree"
                  is-button
                  :key="index"
                  :accessoryBundle="item"
                  @change="onClickDeclineFreebie"
                />
              </v-col>
            </v-row>

            <div
              v-if="hasAlSoBought && !isFromStockCard"
              class="title-also-bought"
            >
              Also Bought
            </div>
            <!-- Apple Care -->
            <!-- <AppleCare
              v-if="appleCare && appleCare.active"
              @change="checkSummary"
              is-button
            /> -->
            <!-- End Apple Care -->

            <!-- Accessory Bundles -->
            <div
              v-if="accessoryBundles.length > 0 && !isFromStockCard"
              class="py-4"
            >
              <AccessoryBundle
                v-for="(accessory, index) in accessoryBundles"
                :key="index"
                :accessoryBundle="accessory"
                @change="checkSummary"
                is-button
              />
            </div>
            <!-- End  Accessory Bundles -->

            <!-- Bundle -->
            <v-row v-if="isShowSwiperBundle && !isFromStockCard">
              <v-col cols="12">
                <span class="text-label">Save With Bundle : </span>
                <span class="font-bold">
                  {{ bundleListLabel }}
                </span>
              </v-col>
              <v-col cols="12">
                <template v-if="bundlesItemsNoFreebie">
                  <BundleSwiper
                    @select="onClickSelectBundle"
                    :data="bundlesItemsNoFreebie"
                    key="bundle"
                  />
                </template>
              </v-col>
            </v-row>
            <!-- End Bundle -->

            <!-- ShipDate -->
            <div ref="cartShip"></div>
            <div
              class="cart-ship-wrapper mt-0 mt-sm-4"
              :class="cartClass"
            >
              <v-row class="no-gutters">
                <v-col cols="12" class="mb-4" v-if="isSoldOut">
                  <div class="text-md-left text-center">
                    <span class="text-bnn-red-2 font-bold">
                      สินค้าหมด
                    </span>
                    ขออภัย สินค้าที่เลือกไม่พร้อมจำหน่ายตอนนี้
                  </div>
                </v-col>

                <v-col cols="12">
                  <div class="wrap-btn-action">
                    <template>
                      <div class="wrap-btn-action-case">
                        <div
                          v-if="isShowBtnDeposit"
                          class="btn-action-item"
                          :class="{ full: !isShowBtnFullPayment }"
                        >
                          <div class="deposit">
                            <v-btn
                              @click="onClickDeposit"
                              id="btn-deposit"
                              class="btn-deposit"
                              block
                              depressed
                              large
                              :outlined="isShowBtnFullPayment"
                              :height="
                                !isShowBtnFullPayment
                                  ? '60px'
                                  : '52px'
                              "
                              :color="
                                !isSoldOut
                                  ? colorBnn['color-bnn']
                                  : 'color-bnn-opacity-90'
                              "
                              :disabled="
                                isSoldOut ||
                                  isDisabled(selectSKU, 'capacity')
                              "
                            >
                              <div class="deposit-content">
                                <div class="text-deposit">
                                  {{ depositTitle }}
                                </div>
                                <div class="text-deposit">
                                  ฿{{ priceDeposit | currency }}.-
                                </div>
                              </div>
                            </v-btn>
                          </div>
                        </div>
                        <div
                          v-if="isShowBtnFullPayment"
                          class="btn-action-item"
                          :class="{ full: !isShowBtnDeposit }"
                        >
                          <div
                            :class="{
                              'w-full': !isShowBtnDeposit,
                            }"
                          >
                            <Button
                              @click="onClickFull"
                              id="btn-full"
                              block
                              depressed
                              large
                              :disabled="
                                disableAction ||
                                  isSoldOut ||
                                  isDisabled(selectSKU, 'capacity')
                              "
                              :height="
                                !isShowBtnDeposit ? '60px' : '52px'
                              "
                              color="color-bnn"
                            >
                              <template v-slot:content>
                                <div class="full-payment-content">
                                  <div>
                                    ชำระเงินเต็มจำนวน
                                  </div>
                                  <div>
                                    ฿{{
                                      priceFullPayment | currency
                                    }}.-
                                  </div>
                                </div>
                              </template>
                            </Button>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="isShowBtnFullPaymentStaff"
                        class="w-full"
                      >
                        <div
                          id="btn-full"
                          @click="onClickFullStaff"
                          class="full-employee"
                        >
                          <span class="text-employee"
                            >ซื้อเต็มจำนวน หรือเลือกผ่อนชำระ 0%</span
                          >
                          <span class="text-payment"> คลิก</span>
                        </div>
                      </div>

                      <v-row class="ship-date-row  w-full no-gutters">
                        <v-col cols="12">
                          <template v-if="!isSoldOut">
                            <div
                              class="ship-date-summary-price-layout"
                            >
                              <div class="ship p-0">
                                <div :class="isShipDateHighlight">
                                  {{ shipDate }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </v-col>
                      </v-row>
                    </template>

                    <v-row
                      class="no-gutters w-full"
                      v-if="isShowConditionHtml"
                    >
                      <v-col cols="12">
                        <div class="condition">
                          <div>
                            <h4>Condition</h4>
                          </div>
                          <div
                            class="mt-3"
                            v-html="conditionHtml"
                          ></div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <template v-if="isSoldOut && !isFromStockCard">
                  <v-col cols="12">
                    <BaseReminder
                      ref="reminderRef"
                      :data="selectSKU"
                      @submit="handleReminder"
                    />
                  </v-col>
                </template>
              </v-row>
            </div>
          </div>
        </div>
        <!-- End Content -->

        <!-- Preview -->
      </v-container>

      <TabsProduct
        :tab-content="isTabContent"
        :tab-compare="isTabCompare"
      >
        <template v-if="isTabContent" v-slot:content>
          <div v-html="footerHtml" class="html-content mt-4"></div>
        </template>
        <template v-if="isTabCompare" v-slot:compare>
          <div v-html="compareHtml" class="html-content mt-4"></div>
        </template>
      </TabsProduct>

      <ModalTerm
        @agree="onAgreeModalTerm"
        @close="modalTerm = false"
        :show="modalTerm"
      />
    </template>
    <template v-else>
      <v-container>
        <v-row>
          <v-col md="6" sm="12">
            <v-skeleton-loader
              v-bind="attrs"
              type="image"
            ></v-skeleton-loader>
          </v-col>
          <v-col md="6" sm="12">
            <v-skeleton-loader
              v-bind="attrs"
              type="article"
            ></v-skeleton-loader>

            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            ></v-skeleton-loader>

            <v-skeleton-loader
              v-bind="attrs"
              type="article"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <div class="footer-margin"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Load from './Load'
import loadCampaign from '../utils/loadcampaign'
import ButtonModel from '@/components/bnn/ButtonModel'
import ButtonColor from '@/components/bnn/ButtonColor'
import ButtonSpec from '@/components/bnn/ButtonSpec'
import Button from '@/components/bnn/Button'
// import Banner from '@/components/bnn/Banner'
import BundleSwiper from '@/components/bnn/BundleSwiper'
import PreviewImageSwiper from '@/components/bnn/PreviewImageSwiper'
import ModalTerm from '@/components/bnn/ModalTerm'
import CountDown from '@/components/bnn/CountDown'
// import AppleCare from '@/components/bnn/AppleCare'
// import DeliveryInfo from '@/components/bnn/DeliveryInfo'
import LabelProduct from '@/components/bnn/LabelProduct'
import TabsProduct from '@/components/bnn/TabsProduct'
import AccessoryBundle from '@/components/bnn/AccessoryBundle'
import branchTypes from '@/config/branchTypes'
// import numeral from 'numeral'
import colorBnn from '@/config/color'
import moment from 'moment'
import routePage from '@/config/routePage'
import config from '@/config/index'
import cartSummary from '@/mixins/cartSummary'
import imageCfUrl from '@/config/imageCfUrl'
import { STOCK_CARD_TYPE } from '@/config/stockCard'
import isBnn from '@/config/isBnn'
import { SHIPPING_DATE } from '@/config/index'
import { PRODUCT_TYPE } from '@/config/product'

const { showFreeBie, showUnsetFree } = config

export default {
  mixins: [cartSummary],

  computed: {
    ...mapState({
      modelLoading: state => state.model.isLoading,
      isLoaded: state => state.model.isLoaded,
      campaign: state => state.campaign.current,
      campaignLoading: state => state.campaign.isLoading,
      model: state => state.model.selectModel,
      selectColor: state => state.model.selectColor,
      selectSKU: state => state.model.selectSKU,
      productData: state => state.model.products,
      paymentTypeData: state => state.paymentType.data,
      branchType: state => state.branchStore.branchType,
      cartSummaryData: state => state.cart.cartSummaryData,
      additionalProductGroup: state => state.model.additionalProduct,
    }),

    ...mapGetters({
      cartItems: 'cart/cartItems' ?? [],
      modelItems: 'model/getModels',
      colorItems: 'model/getColors',
      storageItems: 'model/getStorages',
      priceSummary: 'cart/priceSummary',
      bundlesItems: 'model/getBundles',
      soldOut: 'model/getSoldOut',
      appleCare: 'model/getAppleCare',
      getFreebie: 'model/getFreebie',
      accessoryBundles: 'model/getAccessoryBundles',
    }),

    cartClass() {
      // get position div class cart-ship-wrapper

      return {
        'cart-fixed': this.scrollY > this.positionCartShip,
      }
    },

    isLoading() {
      return this.campaignLoading || this.modelLoading
    },

    isDeposit() {
      return this.branchType === this.branchTypes.BRANCH_TYPE_DEPOSIT
    },

    isDeliveryHome() {
      // Not allow to show delivery home if from stock card
      return (
        this.campaign?.data?.is_delivery_home && !this.$route.query.t
      )
    },

    isShowBtnDeposit() {
      const { t } = this.$route.query
      if (this.campaign?.data?.btn_deposit && !t) {
        return (
          this.paymentTypeData?.filter(i => i.type === 'deposit')
            ?.length > 0
        )
      }
      return false
    },

    isShowBtnFullPayment() {
      if (this.campaign?.data?.btn_full_customer) {
        return (
          this.paymentTypeData?.filter(i => i.type !== 'deposit')
            ?.length > 0
        )
      }
      return false
    },

    isShowBtnFullPaymentStaff() {
      // Hide this
      //   if (this.campaign?.data?.btn_full_staff) {
      //     return (
      //       this.paymentTypeData?.filter(i => i.type !== 'deposit')
      //         ?.length > 0
      //     )
      //   }
      return false
    },

    bundlesItemsNoFreebie() {
      return this.bundlesItems?.filter(
        i =>
          i?.type !== PRODUCT_TYPE.PROMOTION &&
          i?.type !== PRODUCT_TYPE.FREE &&
          i?.type !== PRODUCT_TYPE.FREE_HANDRAISER &&
          i?.type !== PRODUCT_TYPE.UNSET_FREE &&
          i?.type !== PRODUCT_TYPE.FREE_MEMBER,
      )
    },

    isShowSwiperBundle() {
      return this.bundlesItemsNoFreebie?.length > 0
    },

    isFromStockCard() {
      return !!this.$route.query.t || !!this.$route.query.code
    },

    freebieItems() {
      return (
        this.getFreebie?.map(i => {
          return {
            id: i.id,
            sku: i.sku,
            name: i.name,
            image: i.image_url,
            limit: i.limit,
            price: Number(i.price_srp),
          }
        }) ?? []
      )
    },

    isShowLabelFreebie() {
      return (
        this.freebieItems?.length > 0 &&
        this.freebieItems?.filter(i =>
          this.cartItems.find(c => c.sku === i.sku),
        )
      )
    },

    bundlesItemsUnsetFree() {
      return this.bundlesItems?.filter(i => i?.type == 'unset_free')
    },

    isBundlesItemsUnsetFree() {
      return (
        this.showUnsetFree && this.bundlesItemsUnsetFree?.length > 0
      )
    },

    isIncludedUnsetFreeInCart() {
      return this.cartItems?.find(i => i?.isUnsetFree) ? true : false
    },

    modelName() {
      return this.model?.name
    },

    campaignId() {
      return this.campaign?.data?.id ?? ''
    },

    campaignName() {
      return this.campaign?.data?.name
    },

    stickyBanner() {
      return this.campaign?.data?.sticky_banner
    },

    stickyLink() {
      return this.campaign?.data?.sticky_link
    },

    campaignStatus() {
      return this.campaign?.data?.status
    },

    conditionHtml() {
      return this.selectSKU?.condition_html
    },

    rotateHtml() {
      return (
        this.selectSKU?.html_360 || this.selectSKU?.condition_html
      )
    },

    isShowConditionHtml() {
      if (!this.selectSKU?.condition_html) {
        return false
      }
      return true
    },

    previewHtml() {
      return this.selectSKU?.preview_html
      //  ??
      // this.campaign?.data?.preview_html
    },

    footerHtml() {
      return this.selectSKU?.footer_html
      // ??
      // this.campaign?.data?.footer_html
    },

    compareHtml() {
      return this.selectSKU?.compare_html
    },

    isShipDateHighlight() {
      let highlight =
        this.selectSKU?.actual_date &&
        moment(this.selectSKU?.actual_date).isAfter(
          moment(SHIPPING_DATE.FIRST_LOT),
        )

      let className =
        this.selectSKU?.actual_date === SHIPPING_DATE.SECOND_LOT
          ? 'ship-date-highlight lot-2'
          : this.selectSKU?.actual_date === SHIPPING_DATE.THIRD_LOT
          ? 'ship-date-highlight lot-3'
          : ''

      return highlight ? className : ''
    },

    shipDate() {
      return (
        this.selectSKU.shipping_date ||
        this.campaign?.data?.shipdate ||
        'ไม่พบข้อมูล'
      )
    },

    selectColorName() {
      return this.selectColor?.color ?? ''
    },

    selectCapacityName() {
      return this.selectSKU?.size ?? ''
    },

    forceBuyBundle() {
      return this.selectSKU?.force_bundle === 1
    },

    slug() {
      return this.campaign?.data?.slug
    },

    isSoldOut() {
      if (this.soldOut) {
        return this.soldOut
      } else {
        return !this.selectSKU?.active
      }
    },

    sku() {
      return (
        this.selectSKU?.sku ||
        this.selectColor?.data?.[0].sku ||
        this.colorItems?.[0]?.data?.[0].sku
      )
    },

    remainingAmount() {
      return this.priceSummary - this.selectSKU?.price_deposit
    },

    priceDeposit() {
      return this.cartSummaryData?.product_price_deposit_summary ?? 0
    },

    priceFullPayment() {
      // Notes: Previous code is cartSummaryData.final_price
      return this.cartSummaryData?.final_price_original ?? 0
    },

    depositTitle() {
      // TODO: [PRODUCT_DETAIL] Remove the deposit title button
      // if (this.selectSKU?.price_deposit) {
      //   return `มัดจำค่าเครื่อง ฿${numeral(
      //     this.selectSKU?.price_deposit ?? 0,
      //   ).format('0,0')}.-`
      // }
      return `มัดจำค่าเครื่อง`
    },

    thumbnailList() {
      let imageList

      if (!imageList) {
        imageList = this.selectSKU?.images?.map((items, index) => {
          let img = imageCfUrl + 'width=1000/' + items
          return { id: index + 1, imageUrl: img }
        })
      }

      if (!imageList) {
        imageList = this.selectColor?.data?.[0]?.images?.map(
          (items, index) => {
            let img = imageCfUrl + 'width=1000/' + items
            return { id: index + 1, imageUrl: img }
          },
        )
      }

      if (!imageList) {
        imageList = this.model?.model?.map((items, index) => {
          let img =
            imageCfUrl + 'width=1000/' + items.data[0].image_url
          return { id: index + 1, imageUrl: img }
        })
      }

      return imageList ?? []
    },

    disableAction() {
      return !this.selectSKU
    },

    endDateTime() {
      return this.campaign?.data?.ended_at_timestamp * 1000
    },

    endTime() {
      return moment(
        this.campaign?.data?.ended_at_timestamp * 1000,
      ).format('HH:mm')
    },

    timeLeft() {
      if (this.campaign?.data?.status === 'active') {
        return (
          (this.campaign?.data?.ended_at_timestamp -
            this.campaign?.data?.current_datetime_timestamp) *
            1000 ?? -1
        )
      }
      return -1
    },

    bundleListLabel() {
      if (this.selectSKU) {
        const bundleItem = this?.cartItems
          ?.map(item => {
            if (
              item?.type === 'bundle' &&
              item?.sku !== this.appleCare?.sku &&
              !item?.isFreeBie &&
              !item?.isFreeBieMember &&
              !item?.isUnsetFree
            ) {
              return ` ${item?.name} `
            }
          })
          ?.filter(i => i)

        return bundleItem.toString()
      }
      return ''
    },

    titleTextCapacity() {
      return localStorage.getItem('slug')?.indexOf(`watch`) > -1
        ? 'สาย'
        : 'สี'
    },

    hasAdditionalProductGroup() {
      return this.additionalProductGroup?.length > 0
    },

    hasAlSoBought() {
      return (
        this.appleCare &&
        this.appleCare?.active &&
        this.accessoryBundles?.length > 0
      )
    },

    isFromQRCode() {
      const { sku, branch_id, t, code } = this.$route.query
      return sku && branch_id && (t || code)
    },

    isTabContent() {
      return this.footerHtml ? true : false
    },

    isTabCompare() {
      return this.compareHtml ? true : false
    },

    buName() {
      return isBnn ? 'BaNANA' : 'Studio7'
    },

    metaTitle() {
      return `เปิดจอง ${this.campaign?.data?.name ||
        ''} รับสิทธิพิเศษมากมายที่ ${this.buName}`
    },

    metaDescription() {
      return `เปิดจอง ${this.campaign?.data?.name ||
        ''} จองก่อนได้ก่อนที่ ${
        this.buName
      } Online เปิดจอง iPhone iPhone 17, iPhone Air, iPhone 17 Pro และ iPhone 17 Pro Max วันที่ 12 กันยายน 2568 เวลา 19.00 น. วางขายจริง 19 กันยายน 2568 สมัคร 7 Club+ รอรับสิทธิ์ได้เลย`
    },
  },

  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [{ name: 'description', content: this.metaDescription }],
    }
  },

  components: {
    Load,
    ButtonModel,
    ButtonColor,
    ButtonSpec,
    Button,
    BundleSwiper,
    PreviewImageSwiper,
    ModalTerm,
    // Banner,
    CountDown,
    // AppleCare,
    // DeliveryInfo,
    LabelProduct,
    TabsProduct,
    AccessoryBundle,

    BaseReminder: () => import('@/components/base/BaseReminder.vue'),
  },

  data() {
    return {
      branchTypes,
      keyPreview: 0,
      colorBnn,
      modalTerm: false,
      showFreeBie,
      showUnsetFree,
      scrollY,
      positionCartShip: 0,
      attrs: {
        width: '100%',
      },
    }
  },

  async mounted() {
    await this.refetch()
    if (this.isShowBtnDeposit && !this.isShowBtnFullPayment) {
      this.$store.commit(
        'branchStore/setBranchType',
        branchTypes.BRANCH_TYPE_DEPOSIT,
      )
      this.$store.dispatch('cart/setDelivery', 'store')
    }

    window.addEventListener('scroll', this.handleScroll)

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  },

  methods: {
    reload() {
      window.location.reload()
    },

    async refetch() {
      this.$store.commit('cart/resetCouponCode')
      const active = await loadCampaign(this.campaign)

      if (this.campaign?.data?.redirect_url) {
        window.location.href = this.campaign?.data?.redirect_url
      }
      if (active) {
        document.body.style.overflowY = ''
        document.querySelector('html').style.overflowY = ''

        await Promise.all([
          this.$store.dispatch('model/getModel', {
            slug: this.slug,
            reload: true,
          }),
          this.$store.dispatch('model/getStocks', {
            slug: this.slug,
          }),
        ])
        this.$store.dispatch('model/updateStatusSKU')
        this.$store.dispatch('model/reset')
        this.$store.dispatch('bundle/reset')

        // Set route product latest visit
        localStorage.setItem('productLatestVisit', this.slug)

        // Select follow by query param sku
        const { sku } = this.$route.query
        if (sku) {
          this.findSku(this.modelItems, sku)
        }
        // Note: Hide config select sku
        //  else {
        //   if (isBnn) {
        //     let BNN = '195949036255'
        //     this.findSku(this.modelItems, BNN)
        //   } else {
        //     let STU = '195949036255'
        //     this.findSku(this.modelItems, STU)
        //   }
        // }

        // auto select first visit page
        if (!this.isFromQRCode && !this.selectSKU) {
          this.autoSelectSKU('select_model', this.modelItems?.[0])
        }

        await this.$store.dispatch(
          'paymentType/getPaymentType',
          this.campaignId,
        )

        this.$forceUpdate()
      }
    },

    findSku(data, sku) {
      this.isLoading = true

      for (let i in data) {
        for (let j in data[i]?.model) {
          for (let k in data[i]?.model[j]?.data) {
            if (data[i]?.model[j]?.data[k]?.sku === sku) {
              this.$store.dispatch('model/selectModel', data[i])
              this.$store.dispatch(
                'model/selectColor',
                data[i]?.model[j],
              )
              this.$store.dispatch(
                'model/selectSKU',
                data[i]?.model[j]?.data[k],
              )
              this.$store.dispatch('bundle/reset')
              this.autoSelectForceBundle()
              this.autoSelectFreeBundle()
              this.checkSummary()
            }
          }
        }
      }

      this.isLoading = false

      if (!this.selectSKU) {
        if (this.isFromStockCard) {
          this.$router.push({
            name: 'Error',
            params: { error: 'notfound' },
          })
        } else {
          this.autoSelectSKU('select_model', this.modelItems?.[0])
        }
      }
    },

    onClickModel(item) {
      this.keyPreview++
      this.$store.dispatch('model/selectModel', item)
      this.autoSelectSKU('select_model', item)
    },

    onClickColor(item) {
      this.keyPreview++
      this.$store.dispatch('model/selectColor', item)
      this.autoSelectSKU('select_color', item)
    },

    onClickCapacity(item) {
      this.keyPreview++
      this.$store.dispatch('model/selectSKU', item)
      this.$store.dispatch('bundle/reset')
      this.autoSelectForceBundle()
      this.autoSelectFreeBundle()
      this.checkSummary()
      this.$forceUpdate()
    },

    onClickSelectBundle(item) {
      if (!this.forceBuyBundle) {
        this.$store.dispatch('bundle/toggle', item)
      }
      this.$forceUpdate()
      this.checkSummary()
    },

    onClickFull() {
      this.modalTerm = true
      this.$store.commit(
        'branchStore/setBranchType',
        branchTypes.BRANCH_TYPE_FULL_PAYMENT,
        //  branchTypes.BRANCH_TYPE_FULL_PAYMENT,
      )

      if (this.isDeliveryHome) {
        this.$store.dispatch('cart/setDelivery', 'delivery')
      } else {
        this.$store.dispatch('cart/setDelivery', 'store')
      }

      const isStockCardOffline =
        this.$route.query?.t &&
        this.$route.query?.t !== STOCK_CARD_TYPE.QR_ONLINE

      let id = isStockCardOffline
        ? this.paymentTypeData?.filter(
            i => i.type === 'pay-at-store',
          )?.[0]?.id
        : this.paymentTypeData?.filter(i => i.type !== 'deposit')?.[0]
            ?.id

      this.$store.commit('paymentType/setPaymentId', id)
      this.checkSummary()
    },

    onClickFullStaff() {
      this.modalTerm = true
      this.$store.commit(
        'branchStore/setBranchType',
        branchTypes.BRANCH_TYPE_FULL_PAYMENT,
        //  branchTypes.BRANCH_TYPE_FULL_PAYMENT,
      )
      this.$store.dispatch('cart/setDelivery', 'store')
      this.$store.commit(
        'paymentType/setPaymentId',
        this.paymentTypeData?.filter(i => i.type !== 'deposit')?.[0]
          ?.id,
      )
      this.checkSummary()
    },

    onClickDeposit() {
      this.modalTerm = true
      this.$store.commit(
        'branchStore/setBranchType',
        branchTypes.BRANCH_TYPE_DEPOSIT,
        //  branchTypes.BRANCH_TYPE_FULL_PAYMENT,
      )
      this.$store.dispatch('cart/setDelivery', 'store')
      this.$store.commit(
        'paymentType/setPaymentId',
        this.paymentTypeData?.filter(i => i.type === 'deposit')?.[0]
          ?.id,
      )
      this.checkSummary()
      // this.$router.push({
      //   name: 'CustomerAlsoBought',
      //   params: { slug: this.slug },
      // })
    },

    onAgreeModalTerm() {
      this.modalTerm = false
      if (this.hasAdditionalProductGroup) {
        this.$router
          .push({
            name:
              routePage?.[process.env.VUE_APP_CAMPAIGN_TYPE]?.[
                this.branchType
              ]?.[this.$route.name]?.nextPage,
            params: { slug: this.slug },
          })
          .catch(() => true)
      } else {
        this.$router
          .push({
            name: 'Cart',
            params: {
              slug: this.slug,
            },
          })
          .catch(() => true)
      }
    },

    autoSelectForceBundle() {
      if (this.forceBuyBundle) {
        this.bundlesItems.forEach(item => {
          if (item.active) this.$store.dispatch('bundle/toggle', item)
        })

        // if (this.appleCare.active) {
        //   this.$store.dispatch('bundle/toggle', this.appleCare)
        // }
      }
    },

    autoSelectFreeBundle() {
      this.bundlesItems?.forEach(item => {
        if (item.type === PRODUCT_TYPE.FREE && item.active) {
          this.$store.dispatch('bundle/add', item)
        }
      })
      if (
        this.appleCare?.type === PRODUCT_TYPE.FREE &&
        this.appleCare?.active
      ) {
        this.$store.dispatch('bundle/add', this.appleCare)
      }
    },

    autoSelectSKU(
      type = 'select_model',
      selectItem = this.modelItems?.[0],
    ) {
      if (type === 'select_model') {
        let indexColor = 0
        let indexSKU = 0

        if (this.isDisabled(selectItem, 'model')) {
          for (const i in this?.modelItems) {
            if (!this.isDisabled(this?.modelItems?.[i], 'model')) {
              selectItem = this?.modelItems?.[i]
              this.$store.dispatch('model/selectModel', selectItem)
              break
            }
          }
        }

        for (const i in selectItem?.model) {
          if (!this.isDisabled(selectItem?.model?.[i], 'color')) {
            // ? Note: Ignore disabled
            // if (selectItem?.model?.[i]) {
            indexColor = i
            break
          }
        }
        for (const i in selectItem?.model?.[indexColor]?.data) {
          if (
            !this.isDisabled(
              selectItem?.model?.[indexColor]?.data?.[i],
              'capacity',
            )
          ) {
            // ? Note: Ignore disabled
            //   if (selectItem?.model?.[indexColor]?.data?.[i]) {
            indexSKU = i
            break
          }
        }

        this.$store.dispatch(
          'model/selectColor',
          selectItem?.model?.[indexColor],
        )
        this.onClickCapacity(
          selectItem?.model?.[indexColor]?.data?.[indexSKU],
        )
      } else if (type === 'select_color') {
        let indexSKU = 0
        for (const i in selectItem?.data) {
          if (!this.isDisabled(selectItem?.data?.[i], 'capacity')) {
            // ? Note: Ignore disabled
            //   if (selectItem?.data?.[i]) {
            indexSKU = i
            break
          }
        }
        this.onClickCapacity(selectItem?.data?.[indexSKU])
      }
    },

    isDisabled(item, type = 'model') {
      // TODO: check nesting stock
      // old code return false && item
      let active = false

      const { sku } = this.$route.query

      if (this.isFromQRCode) {
        if (item === this.selectSKU) {
          return false
        } else if (type === 'model') {
          for (const models of item?.model) {
            for (const model of models?.data) {
              if (model?.active && model?.sku === sku) {
                active = true
                break
              }
            }
          }
          return !active
        } else if (type === 'color') {
          item?.data?.forEach(i => {
            if (i?.active && i?.sku === sku) {
              active = true
            }
          })
          return !active
        }
        return true
      } else {
        if (type === 'model') {
          for (const models of item?.model) {
            for (const sku of models?.data) {
              if (sku?.active) {
                active = true
                break
              }
            }
          }
          return !active
        } else if (type === 'color') {
          item?.data?.forEach(i => {
            if (i?.active) {
              active = true
            }
          })
          return !active
        } else if (type === 'capacity') {
          return !item?.active
        }
      }
    },

    handleScroll() {
      const checkoutActionHeight = document.querySelector(
        '.cart-ship-wrapper',
      )?.offsetHeight
      this.scrollY =
        window.scrollY + window.innerHeight - checkoutActionHeight
      // this.scrollY = window.scrollY
      this.positionCartShip = this.$refs.cartShip?.offsetTop
    },

    onClickDeclineFreebie() {
      const includeUnsetFree = this.cartItems?.find(
        item => item.isUnsetFree,
      )

      if (includeUnsetFree) {
        this.cartItems.forEach(item => {
          // Remove freebie from cart with included condition unset free
          if (
            item.isFreeBie &&
            includeUnsetFree?.condition?.includes(item.sku)
          ) {
            this.$store.dispatch('bundle/remove', item)
          }
        })
      } else {
        // add all freebie to cart
        this.autoSelectFreeBundle()
      }

      this.checkSummary()
      this.$forceUpdate()
    },

    async handleReminder(event) {
      try {
        await this.$store.dispatch('reminder/reminderRequest', event)

        if (this.$store.getters['reminder/isSuccess']('submit')) {
          this.$refs.reminderRef.close()
        }
      } catch {
        // Do nothing
      }
    },
  },
}
</script>

<style lang="stylus" scoped>

// ::v-deep img {
//   width: 100%;
// }

.product-detail {
  margin-top: 150px;
  @media small {
    margin-top: 200px;
  }
}

.color-content {
  display: grid;
  gap: 16px 4px;
  grid-template-columns: repeat(8, 1fr);

  @media small {
   display: flex;
   justify-content: space-between;
   flex-wrap: wrap !important;
   background: white;
   padding: 0.5rem 1rem
   border-radius: 8px
  }
}

.capacity-content {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(5, 1fr);

  @media screen and (max-width: 768px) {
     grid-template-columns: repeat(4, 1fr);
  }
}

.condition {
    display: block;
    overflow: hidden;
    border-radius: 8px
    background: $color-bnn-gray-light-2
    padding: 0.75rem 1rem
    @media small {
      overflow: scroll;
      max-height: 120px
    }
}

.text-label {
  color: $color-bnn-gray-medium-2;
  font-weight: bold
}

.price-summary {
  color:  $color-text-price
  color:  $color-bnn
  font-weight: bold
  font-size: 1rem
  text-align: right
  // line-height: 2.25rem
}

.price-summary-deposit {
  color:  $color-bnn
  font-weight: bold
  font-size: 1rem
  text-align: right
  // line-height: 2.25rem
}

.text-bnn-red-2 {
  color: #d73d3d
}

.text-ship-date {
    color: $color-bnn-blue-2
    font-weight: bold
}

.gallery {
    display: flex
    justify-content: center
    flex-direction: column
    justify-content: flex-start
    padding-right: 5rem
    margin-top: -2.2rem
    @media screen and (max-width: 960px) {
      padding: 0
      display: flex
      justify-content: center
      width: 100%
    }
}

.harry-up
    color: $color-text-harry-up

.preview-html
  overflow: hidden

@media screen and (max-width: 768px)
  .gallery
    padding 0

.button-to-cart-action
    margin-left: -12x !important
    margin-right: -12px !important
    // @media screen and (max-width: 768px)
    //   margin-left: 0 !important
    //   margin-right: 0 !important
    //   position: fixed
    //   z-index 50
    //   width: 100%
    //   bottom: 0
    //   left: 0
    //   background: #fff
    //   box-shadow: 1px 1px 2px 1px $color-gray-200;

.wrap-btn-action
  display: flex
  flex-wrap: wrap
  gap: 0.75rem

.wrap-btn-action-case
  width: 100%
  display: flex
  flex-wrap: wrap
  gap: 0.75rem
  @media screen and (min-width: 768px)
    flex-wrap: nowrap;
    gap: 1rem
  .btn-action-item
    flex-basis: 100%;
    @media screen and (min-width: 768px)
      flex-basis: 50%;
      &.full
        flex-basis: 100%;

@media screen and (max-width: 960px)
  .footer-margin
    margin-bottom: 150px;


.product-detail-layout
  display: flex
  justify-content: center
  flex-direction: row
  margin-right: -12px
  margin-left: -12px
  .pdp-preview-swiper
    width: 50%
    @media screen and (max-width: 960px)
      width: 100%
  .pdp-content
    width: 50%
    padding: 12px
    @media screen and (max-width: 960px)
      width: 100%
  @media screen and (max-width: 960px)
    flex-direction: column

::v-deep .v-btn{
    .v-btn__content {
        width: 100%;
        flex-wrap: wrap !important;
        text-align: left;
    }
}

.btn-deposit {
    padding: 0.75rem !important
    font-weight: bold !important
    font-size: 0.875rem !important
    background: $color-deposit !important

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.5
    }

}

.full
  .btn-deposit
    background: $color-bnn !important
    .text-deposit
      color: $color-bnn-btn-text !important
      font-size: 1rem !important
  .full-payment-content
    font-size: 1rem !important


.btn-bnn-default
  padding: 0.75rem !important

.text-deposit
    color: $color-deposit-text
.text-deposit-desc
    color: #00000073
    font-size: 12px

.deposit-content,.full-payment-content
  width: 100%
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  align-items: center
  white-space: nowrap

.product-label-layout
  display: flex
  flex-wrap: auto

.action-contain-layout
  display flex
  width: 100%
  flex-direction: row
  justify-content: space-between
  flex-wrap: wrap
  padding: 0.5rem 0 2px 0
  .soldOut
    width: 100%
    padding: 12PX
  .deposit
    width: 50%
    padding: 12PX
    @media screen and (max-width: 960px)
      width: 100%
    @media small
      padding 4px 12px
  .full
    width: 50%
    padding: 12PX
    @media screen and (max-width: 960px)
      width: 100%
    @media small
      padding 4px 12px
  .full-employee
    width: 100%
    padding: 12PX
    cursor: pointer
    .text-employee
      font-weight: bold
    .text-payment
      margin-left: 0px
      font-weight: bold
      color: $color-bnn
  @media screen and (max-width: 960px)
    flex-direction: row
    align-items: center

.w-full
  width: 100% !important

.ship-date-summary-price-layout
  display flex
  justify-content: space-between
  width: 100%
  @media tablet
    flex-direction: row
    align-items: flex-start
    justify-content: space-between
    text-align: center
  align-items: flex-start
  .ship
    max-width: 100%
    color: $color-bnn-border-dark-btn
    .ship-date
      font-weight: bold
      color: $color-bnn-border-dark-btn
    @media tablet
      // padding: 0.5rem 0
      width: 100%

  .price
    color: $color-bnn-border-dark-btn
    @media tablet
      text-align: right
      padding: 0.5rem 0
      width: 100%

.desktop-only
  display: block
  @media tablet
    display: none

.html-content
  overflow: auto
  width: 100%
  min-width: 100%
  justify-content: center;

.hurry-up-label
  display: block
  @media screen and (max-width: 600px)
    display: none

.model-container
  @media small
    display: grid
    grid-template-columns: repeat(2, 1fr)
    gap: 0 1rem

.campaign-name-content {
  @media small {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-top: -100px
    padding 1rem 0;
  }
}

.cart-fixed {
  @media small {
    position: fixed
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 50
    width: 100%
    bottom: 0
    left:0
    padding: 1rem
    background: white
    box-shadow: 1px 1px 2px 1px $color-gray-200;
  }
}

.ship-date-row {
  margin-top: 0
  // @media small {
  //   margin-top: -18px
  // }
}

.model-wrapper {
  width: 100%

  @media small {
    width: calc(100% + (1.5rem))
    min-width: calc(100% + (1.5rem))
    margin-left: -1.25rem
    padding-left: 1.25rem
    padding-top: 1rem
    background-color: $color-bnn-gray-light-2
  }
}

.color-wrapper{
  width: 100%

  @media small {
    width: calc(100% + (1.75rem))
    min-width: calc(100% + (1.75rem))
    margin-left: -1.25rem
    padding-left: 1.25rem
    background-color: $color-bnn-gray-light-2
  }
}

.capacity-wrapper {
  width: 100%

  @media small {
    width: calc(100% + (1.75rem))
    min-width: calc(100% + (1.75rem))
    margin-left: -1.25rem
    padding-left: 1.25rem
    background-color: $color-bnn-gray-light-2
    padding-bottom: 1rem
  }
}

.is-mobile {
  display: none
  @media screen and (max-width: 600px) {
    display: block
  }
}

.is-desktop {
  display: block
  @media screen and (max-width: 600px) {
    display: none
  }
}

.title-also-bought {
  padding-top: 1rem
  font-weight: bold
  font-size: 1.25rem
}

.select-by-sku
  .btn-model.disabled
    color: $color-bnn-gray-medium-2
  .btn-model.disabled,
  .btn-color.disabled,
  .btn-spec.disabled
    event-pointer: none
    cursor: not-allowed

.v-btn--disabled.v-btn--outlined
  opacity 0.45
  border-color: $color-bnn !important
  color: $color-bnn-btn-text !important
  .text-deposit
    color: $color-bnn !important

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).btn-bnn-default
  opacity 0.45
  background-color: $color-bnn !important
  color: $color-bnn-btn-text !important
</style>
